import { useEffect, useMemo, useRef, useState } from 'react';
import { buildPlacement, inferBand } from '../engine/session';
import type { LevelId } from '../content/sequence';
import { useGameStore } from '../store/gameStore';
import { BeatView } from './BeatView';

/**
 * First-run, game-framed placement: a short warm-up that climbs the levels to find
 * where he starts to stumble, then sets the starting band one notch from there.
 * It's just the first few beats — seamless, not a visible "test".
 */
export function Placement() {
  const coins = useGameStore((s) => s.coins);
  const addCoins = useGameStore((s) => s.addCoins);
  const completePlacement = useGameStore((s) => s.completePlacement);

  const beats = useMemo(() => buildPlacement(), []);
  const [i, setI] = useState(0);
  const results = useRef<{ level: LevelId; passed: boolean }[]>([]);

  // When the warm-up is done, infer the band and hand off to the game (once).
  useEffect(() => {
    if (beats.length > 0 && i >= beats.length) {
      completePlacement(inferBand(results.current));
    }
  }, [i, beats.length, completePlacement]);

  if (i >= beats.length) return null; // transitioning into the game

  const beat = beats[i];
  return (
    <BeatView
      beat={beat}
      done={i}
      total={beats.length}
      coins={coins}
      onComplete={(r, earned) => {
        addCoins(earned);
        // "Can read this level" = found the broken word cleanly (gentler than firstTry).
        results.current.push({ level: beat.level, passed: r.caught });
        setI((n) => n + 1);
      }}
    />
  );
}
